import React from "react";
import ReactDOM from "react-dom";

import NotificationPopup from "components/navigation/notifications/NotificationPopup";

const PublicNotificationPopup = ({ notification }) => {
  const drawerRef = React.createRef();

  return ReactDOM.createPortal(
    <div ref={drawerRef} className="notification-popup-wrapper">
      <NotificationPopup
        key={notification.id}
        notification={notification}
      />
    </div>,
    document.body
  );
};

export default PublicNotificationPopup;
